import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MedicationHistory {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  MedicationHistoryData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: MedicationHistory = {
  isLoading: false,
  error: false,
  message: null,
  MedicationHistoryData: [],
  Items: [],
  Pagination: [],
};

const MedicationHistorySlice = createSlice({
  name: "medicationhistory",
  initialState,
  reducers: {
    loadingMedicationHistory: (
      state: MedicationHistory,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setMedicationHistory: (
      state: any,
      action: PayloadAction<MedicationHistory>
    ) => {
      return action.payload;
    },
    clearData: (state: MedicationHistory, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingMedicationHistory, setMedicationHistory, clearData } =
  MedicationHistorySlice.actions;

export default MedicationHistorySlice.reducer;
